export default [
    {
        path: '/admin/pay-user-variables',
        name: 'pay-user-variable',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/pay-user-variable/index.vue')
    }
]
